var hubspotFormLoaded = false;
var hubspotScriptLoading = false;

function loadHubspotForm() {
    if (hubspotFormLoaded) return;

    function createForm() {
        if (!window.hbspt || hubspotFormLoaded) return;

        window.hbspt.forms.create({
            region: "na1",
            portalId: "5089160",
            formId: "2b451706-3df5-454b-b780-e0548d6b4d20",
            target: "#fslp-hubspot-form"
        });

        hubspotFormLoaded = true;
        hubspotScriptLoading = false;
    }

    if (window.hbspt) {
        createForm();
        return;
    }

    if (hubspotScriptLoading) return;
    hubspotScriptLoading = true;

    var script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
    script.async = true;
    script.onload = createForm;
    script.onerror = function() {
        hubspotScriptLoading = false;
    };
    document.head.appendChild(script);
}

function toggleVisibility(showIndex, hideIndex) {
    var showElement = document.querySelector('.recommended-product .FSLP.completed-title:nth-child(' + showIndex + ')');
    var hideElement = document.querySelector('.recommended-product .FSLP.completed-title:nth-child(' + hideIndex + ')');

    if (showElement) {
        showElement.classList.remove('--hide');
        showElement.classList.add('--show');
    }
    if (hideElement) {
        hideElement.classList.add('--hide');
        hideElement.classList.remove('--show');
    }
}

function pluralToSingular() {
    if (localStorage.recommendedProduct) {
        toggleVisibility(3, 2);
    }
    if (localStorage.recommendedProduct2 || localStorage.recommendedProduct3 || localStorage.recommendedProduct4) {
        toggleVisibility(2, 3);
    }
}

function quizToForm() {
    var formCtr = document.querySelector('.FSLP__container');
    var recProductCtr = document.querySelector('.recommended-product');
    var quizOuterCtr = document.querySelector('.quiz-outer-ctr__black-mask');
    var quizSpaceHolder = document.querySelector('.quiz-outer-ctr__space-holder');

    loadHubspotForm();

    fadeOut(recProductCtr, 200);
    fadeOut(quizOuterCtr, 200);

    setTimeout(function() {
        fadeIn(formCtr, 200);

        if (formCtr) {
            formCtr.classList.add('--show');
            formCtr.classList.remove('--hide');
        }
        if (recProductCtr) {
            recProductCtr.classList.add('--hide');
            recProductCtr.classList.remove('--show');
        }
        if (quizOuterCtr) {
            quizOuterCtr.classList.add('--hide');
            quizOuterCtr.classList.remove('--show');
        }
        if (quizSpaceHolder) {
            quizSpaceHolder.classList.add('--hide');
            quizSpaceHolder.classList.remove('--show');
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 200);

    var products = [
        'CRX', 'CRX-M', 'CRY', 'CRY-M', 'CR2', 'CR41',
        'SILICA-GEL', 'Activated-Alumina', 'B80', 
        'CRAC', 'G-CRAC', 'Perform-5000', 'Perform-6000', 
        'PR-W', 'PR-O', 'MB-5'
    ];

    var colors = ['#e0e0e0', '#f0f0f0'];
    var colorIndex = 0;

    products.forEach(function(product) {
        if (localStorage.recommendedProduct === product || 
            localStorage.recommendedProduct2 === product || 
            localStorage.recommendedProduct3 === product || 
            localStorage.recommendedProduct4 === product) {

            var element = document.querySelector('.FSLP__' + product);
            if (element) {
                element.classList.add('--show');
                element.classList.remove('--hide');
                element.style.backgroundColor = colors[colorIndex];
                colorIndex = (colorIndex + 1) % colors.length;
            }
        }
    });

    var products2 = [
        'CRX', 'CRX-M', 'CRY', 'CRY-M', 'CR2', 'CR41',
        'SILICA-GEL', 'Activated-Alumina', 'B80', 
        'CRAC', 'G-CRAC', 'Perform-5000', 'Perform-6000', 
        'PR-W', 'PR-O', 'MB-5'
    ];

    products2.forEach(function(product2) {
        if (localStorage.recommendedProduct === product2 || 
            localStorage.recommendedProduct2 === product2 || 
            localStorage.recommendedProduct3 === product2 || 
            localStorage.recommendedProduct4 === product2) {

            if (product2 === 'Perform-5000') product2 = 'Perform 5000';
            if (product2 === 'Perform-6000') product2 = 'Perform 6000';
            if (product2 === 'SILICA-GEL') product2 = 'CR60';
            if (product2 === 'Activated-Alumina') product2 = 'CRAG';

            var checkbox = document.querySelector('input[value="' + product2 + '"]');
            if (checkbox) {
                checkbox.click();
                checkbox.checked = true;
                checkbox.dispatchEvent(new Event('change'));
            }
        }
    });

    function applyStyles(widthClass, fontSizeClass, showIndex, hideIndex) {
        document.querySelectorAll('.FSLP__products-ctr div').forEach(el => el.classList.add(widthClass));
        document.querySelectorAll('.FSLP2.quiz-product-title').forEach(el => el.classList.add(fontSizeClass));

        var showElement = document.querySelector('.FSLP__sample2 p:nth-child(' + showIndex + ')');
        var hideElement = document.querySelector('.FSLP__sample2 p:nth-child(' + hideIndex + ')');

        if (showElement) {
            showElement.classList.remove('--hide');
            showElement.classList.add('--show');
        }
        if (hideElement) {
            hideElement.classList.add('--hide');
            hideElement.classList.remove('--show');
        }
    }

    if (localStorage.recommendedProduct) {
        applyStyles('--uno-width', '--uno-font-size', 2, 1);
    }
    if (localStorage.recommendedProduct2) {
        applyStyles('--dos-width', '--dos-font-size', 1, 2);
    }
    if (localStorage.recommendedProduct3) {
        applyStyles('--tres-width', '--tres-font-size', 1, 2);
    }
    if (localStorage.recommendedProduct4) {
        applyStyles('--quatro-width', '--quatro-font-size', 1, 2);
    }

    localStorage.clear();
}
